import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BookingPage from './app/routes/BookingPage';
import SuccessPage from './app/routes/SuccessPage';
import ManagePage from './app/routes/ManagePage';
import JoinPage from './app/routes/JoinPage';
import NotFound from './app/routes/NotFound';
import RootRedirect from './app/routes/RootRedirect';
import ShortLinkRedirect from './app/routes/ShortLinkRedirect';
import DevHelpPage from './app/routes/DevHelpPage';
import { YandexMetrikaSpaHits } from './shared/analytics/YandexMetrikaSpaHits';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <YandexMetrikaSpaHits />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/dev" element={<DevHelpPage />} />
        <Route path="/r/:shortCode" element={<ShortLinkRedirect />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/booking/:slug" element={<BookingPage />} />
        <Route path="/booking/:slug/success" element={<SuccessPage />} />
        <Route path="/booking/:slug/manage" element={<ManagePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;

